/**
 * TemplateAnalyticsPage - Sprint 11
 * Full page view for template usage analytics
 */

import React from 'react';
import TemplateAnalyticsWidget from '../components/TemplateAnalyticsWidget';

const TemplateAnalyticsPage = () => {
  return (
    <div className="p-6 max-w-7xl mx-auto" data-testid="template-analytics-page">
      <TemplateAnalyticsWidget expanded />
    </div>
  );
};

export default TemplateAnalyticsPage;
